import { useTranslation } from 'react-i18next'

import { Header } from '@/shared/components/ui/layout'
import { LinkButton } from '@/shared/components/ui/link-button'
import { ampli } from '@/shared/lib/ampli'
import { formatNumber } from '@/shared/tools/locale'

export default function SelectionMessagePanel({
	selectedProducts,
	totalProducts,
	isAllSelected,
	onSelectAllProducts,
	onClearSelection,
}: {
	selectedProducts: number
	totalProducts: number
	isAllSelected: boolean
	onSelectAllProducts: () => void
	onClearSelection: () => void
}) {
	const { t } = useTranslation()

	const count = formatNumber(totalProducts)
	const handleSelectAllProducts = () => {
		ampli.tableSelectAllItemsOnAllPages()
		onSelectAllProducts()
	}
	const handleClearSelected = () => {
		ampli.tableClearSelection()
		onClearSelection()
	}

	return (
		<Header className='mb-2 h-8 items-center justify-center gap-1 rounded-lg border bg-secondary text-sm'>
			<span className='font-bold'>
				{isAllSelected ? count : selectedProducts}
			</span>
			{t('app.products_selected', { defaultValue: 'products selected' })}.
			{isAllSelected ? (
				<LinkButton variant='brand' onClick={handleClearSelected}>
					{t('app.clear_selection', { defaultValue: 'Clear selection' })}
				</LinkButton>
			) : (
				<LinkButton variant='brand' onClick={handleSelectAllProducts}>
					{t('app.select_all_products', {
						count,
						defaultValue: `Select all ${count} products`,
					})}
				</LinkButton>
			)}
		</Header>
	)
}
